var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, Box, useMediaQuery, useTheme } from '@mui/material';
import loadergif from './loader.gif';
import { useAppSelector } from '../../../application/store/useStore';
import { QueryStatus } from '@reduxjs/toolkit/query';
var Loader = function (_a) {
    var open = _a.open;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var loaderExcludedEndpointNames = [
        'getAnswer',
        'getMachineDocument',
        'startMachine',
        'getMachineStatus',
        'getHealth',
        'translateText',
        'detectLanguage',
        'getMicrosoftGraphToken',
        'getTranslationAnswer',
        'keepAlive',
        'getGlobalSearchAll',
        'getGlobalSearchFiles',
        'getGlobalSearchFileResults',
        'getNewMachineDocumentsCount'
    ];
    var isSomeQueryPending = useAppSelector(function (state) {
        var activeQueries = Object.entries(state.monteurApi.queries)
            .filter(function (_a) {
            var _b = __read(_a, 2), key = _b[0], query = _b[1];
            return (query === null || query === void 0 ? void 0 : query.status) === QueryStatus.pending;
        })
            .map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
        return activeQueries.some(function (query) { return !loaderExcludedEndpointNames.some(function (excluded) { return query.startsWith(excluded); }); });
    });
    return (_jsx(Backdrop, { open: isSomeQueryPending || (open !== undefined && open), sx: {
            color: '#fff',
            zIndex: function (theme) { return theme.zIndex.drawer + 1; },
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.2)'
        }, children: _jsx(Box, { component: 'img', src: loadergif, alt: 'Loading...', sx: { width: isMobile ? '150px' : undefined, height: isMobile ? '150px' : undefined } }) }));
};
export default Loader;
